import request from '@/utils/request'

export function upload(data) {
  return request({
    url: `admin/upload/uploadFile`,
    method: 'post',
    data: data
  })
}

//商家下拉
export function business(data) {
  return request({
    url: `admin/select/business`,
    method: 'get',
    params: data
  })
}

// 管理员下拉
export function sysUser() {
  return request({
    url: `admin/select/sys-user`,
    method: 'get',
  })
}

// 敏感词下拉
export function wordCategory() {
  return request({
    url: `admin/select/sensitive-word-category`,
    method: 'get',
  })
}

// 报关城区大厦下拉
export function areaSelect() {
  return request({
    url: `admin/select/urban-area`,
    method: 'get',
  })
}

// 获取业务配置 
export function getConfig(data) {
  return request({
    url: `admin/promote/service-config`,
    method: 'get',
    params: data
  })
}

// 保存设置
export function saveConfig(data) {
  return request({
    url: `admin/promote/save`,
    method: 'post',
    data: data
  })
}

// 获取汇率配置
export function getRate() {
  return request({
    url: `admin/sys-config/exchange-rate`,
    method: 'get',
  })
}

// 设置汇率
export function saveRate(data) {
  return request({
    url: `admin/sys-config/exchange-rate`,
    method: 'post',
    data: data
  })
}

// 商户地址下拉
export function getAddress() {
  return request({
    url: `admin/select/business-address`,
    method: 'get',
  })
}
